<template>
  <transition name="fade">
    <div v-if="toast.visible" :class="['toast', toast.type]">
      {{ toast.message }}
    </div>
  </transition>
</template>

<script setup>
import { useToastStore } from '../../stores/ToastStore';

const toast = useToastStore()
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 12px 18px;
  border-radius: 6px;
  color: white;
}

.toast.info { background: #3498db; }
.toast.success { background: #2ecc71; }
.toast.error { background: #e74c3c; }
.toast.warn { background: #e7a53c; }

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>